import { StatusCodes } from "http-status-codes";
import { t } from "i18next";

import { downloadFile } from "@/modules/file-downloader";

import { ImportExportStatus } from "./importToolXSLX.constant";

export const handleImportSuccess = (data) => ({
  status: ImportExportStatus.success,
  data,
});

export const handleImportErrors = (error, notify) => {
  // TODO https://stelar.atlassian.net/browse/DEV-4217
  const errorMessageKey =
    error?.code === "ERR_NETWORK"
      ? "global:uploadFailedVolumeTooLarge"
      : "global:uploadFailed";
  notify.error({ title: t(errorMessageKey) });

  const response = error?.response;
  if (response?.status === StatusCodes.UNPROCESSABLE_ENTITY && response?.data) {
    return {
      status: ImportExportStatus.fail,
      errorMessage: response.data.message,
      errors: response.data.errors,
    };
  }

  return { status: ImportExportStatus.fail };
};

export const handleExportSuccess = (url) => {
  downloadFile({ url });
  return { status: ImportExportStatus.success };
};

export const handleExportErrors = (response, notify) => {
  notify.error({ title: t("global:exportFailed") });

  if (response?.status === StatusCodes.UNPROCESSABLE_ENTITY && response?.data) {
    return { status: ImportExportStatus.fail, ...response.data };
  }
  return { status: ImportExportStatus.fail };
};
